import { z } from 'zod';
export const visibilitySchema = z.enum(['PUBLIC', 'INTERNAL', 'RESTRICTED']);
/** Vault-relative path. Forward slashes, no traversal, must end in .md */
export const notePathSchema = z
    .string()
    .min(1)
    .max(512)
    .regex(/^(?!\/)(?!.*\.\.)(?!.*\/\/)[^\\:*?"<>|]+\.md$/, 'invalid vault path');
export const noteCreateSchema = z.object({
    /** Explicit path. If omitted, derived from type folder + slugged title. */
    path: notePathSchema.optional(),
    title: z.string().min(1).max(300),
    type: z.string().min(1).max(64).default('note'),
    frontmatter: z.record(z.unknown()).optional(),
    /** Body markdown. If omitted, the type template is used. */
    body: z.string().optional(),
});
export const noteUpdateSchema = z.object({
    /** Full raw file content (frontmatter + body). */
    raw: z.string(),
    /** contentHash the client loaded. Mismatch on disk -> 409. */
    baseHash: z.string().min(8),
});
export const noteRenameSchema = z.object({
    newPath: notePathSchema,
});
export const noteListQuerySchema = z.object({
    type: z.string().optional(),
    tag: z.string().optional(),
    folder: z.string().optional(),
    since: z.string().datetime().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(100),
    offset: z.coerce.number().int().min(0).default(0),
    sort: z.enum(['mtime', 'title', 'path']).default('mtime'),
});
export const noteTypeSchemaDefSchema = z.object({
    key: z.string().regex(/^[a-z][a-z0-9_-]*$/),
    label: z.string().min(1),
    icon: z.string().nullable().default(null),
    colour: z.string().nullable().default(null),
    fieldSchema: z.record(z.unknown()).default({}),
    template: z.string().default(''),
    builtin: z.boolean().default(false),
    folder: z.string().nullable().default(null),
});
//# sourceMappingURL=note.js.map